export default __webpack_public_path__ + "static/media/jenniePet2.10f07177.jpg";